export default __webpack_public_path__ + "static/media/globally-recognised.58cc02b2.png";